import { createSelector } from 'reselect';

const selectRoles = ({ roles }) => roles;

const selectListRoles = createSelector(
  selectRoles,
  ({ listRoles }) => listRoles,
);

const selectListRolesData = () =>
  createSelector(selectListRoles, ({ data }) => data);
const selectListRolesAsSelectOptions = () =>
  createSelector(selectListRoles, ({ data }) => {
    const { roles = [] } = data;

    return roles.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  });
const selectListRolesLoading = () =>
  createSelector(selectListRoles, ({ isLoading }) => isLoading);
const selectListRolesError = () =>
  createSelector(selectListRoles, ({ error }) => error);

const selectGetRole = createSelector(selectRoles, ({ getRole }) => getRole);

const selectGetRoleData = () =>
  createSelector(selectGetRole, ({ data }) => data);
const selectGetRoleLoading = () =>
  createSelector(selectGetRole, ({ isLoading }) => isLoading);
const selectGetRoleError = () =>
  createSelector(selectGetRole, ({ error }) => error);

const selectCreateRole = createSelector(
  selectRoles,
  ({ createRole }) => createRole,
);

const selectCreateRoleData = () =>
  createSelector(selectCreateRole, ({ data }) => data);
const selectCreateRoleLoading = () =>
  createSelector(selectCreateRole, ({ isLoading }) => isLoading);
const selectCreateRoleError = () =>
  createSelector(selectCreateRole, ({ error }) => error);

const selectUpdateRole = createSelector(
  selectRoles,
  ({ updateRole }) => updateRole,
);

const selectUpdateRoleData = () =>
  createSelector(selectUpdateRole, ({ data }) => data);
const selectUpdateRoleLoading = () =>
  createSelector(selectUpdateRole, ({ isLoading }) => isLoading);
const selectUpdateRoleError = () =>
  createSelector(selectUpdateRole, ({ error }) => error);

const selectRemoveRole = createSelector(
  selectRoles,
  ({ removeRole }) => removeRole,
);

const selectRemoveRoleData = () =>
  createSelector(selectRemoveRole, ({ data }) => data);
const selectRemoveRoleLoading = () =>
  createSelector(selectRemoveRole, ({ isLoading }) => isLoading);
const selectRemoveRoleError = () =>
  createSelector(selectRemoveRole, ({ error }) => error);

export default {
  selectListRolesData,
  selectListRolesAsSelectOptions,
  selectListRolesLoading,
  selectListRolesError,

  selectGetRoleData,
  selectGetRoleLoading,
  selectGetRoleError,

  selectCreateRoleData,
  selectCreateRoleLoading,
  selectCreateRoleError,

  selectUpdateRoleData,
  selectUpdateRoleLoading,
  selectUpdateRoleError,

  selectRemoveRoleData,
  selectRemoveRoleLoading,
  selectRemoveRoleError,
};
